import { render, staticRenderFns } from "./ReturnExchange.vue?vue&type=template&id=11f39f0c&scoped=true&"
import script from "./ReturnExchange.vue?vue&type=script&lang=js&"
export * from "./ReturnExchange.vue?vue&type=script&lang=js&"
import style0 from "./ReturnExchange.vue?vue&type=style&index=0&id=11f39f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f39f0c",
  null
  
)

export default component.exports